module.exports = __webpack_public_path__ + "img/logo.f66dbf88.png";